// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 53 ? "webfontloader" : chunkId) + "." + {"53":"4fb3beac","892":"16265c6f"}[chunkId] + ".js";
};